import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";
// import Registration from "../views/Registration.vue";
// import ConfirmAge from "../views/ConfirmAge.vue";
import RegisterForEvent from "../views/RegisterForEvent.vue";
import SocialLead from "../views/SocialLead.vue";
import ChivasLounge from "@/views/ChivasLounge.vue";
// import Scuderiaferrari from "../views/Scuderiaferrari.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: HomeView,
  // },
  {
    path: "/registration",
    name: "registration",
    component: SocialLead,
  },
    {
    path: "/chivaslounge",
    name: "chivaslounge",
    component: ChivasLounge,
  },
  // {
  //   path: "/",
  //   name: "confirm-age",
  //   component: ConfirmAge,
  // },
  {
    path: "/register-for-event",
    name: "RegisterForEvent",
    component: RegisterForEvent,
  },
  //  {
  //   path: "/crystalgold",
  //   name: "SocialLead",
  //   component: SocialLead,
  // },
  //  {
  //   path: "/scuderiaferrari",
  //   name: "ScuderiaFerrari",
  //   component: Scuderiaferrari,
  // },
  
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: '/:pathMatch(.*)*', // Перехватывает всё, что не подошло выше
    name: 'NotFound',
    component: () => import('../views/NotFoundView.vue') // Путь к вашему компоненту заглушки
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});
// Глобальный guard для проверки возраста
router.beforeEach((to, from, next) => {
    // const userAge = JSON.parse(localStorage.getItem('userAge'));

    // если идём на главную и возраст есть → сразу на /chivas
    // if (to.path === "/") {
    //   if (userAge) {
    //     return next("/jameson");
    //   }
    //   return next(); // иначе остаёмся на главной
    // }

    // // если идём на /chivas, но возраста нет → возвращаем на /
    // if (to.path === "/jameson" && !userAge) {
    //   return next("/");
    // }

    next();
});



export default router;
